'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/dist/client/link';
import { FC, ReactNode } from 'react';
import Image from '@/components/Image';
import AnimatedButton from '@/components/shared/AnimatedButton';
import { LeadMagnetMedia } from '@/types/lead-magnet';
import css from './style.module.scss';
interface Props {
  logo: LeadMagnetMedia | null;
  exitLabel: string;
  onLogoClick: () => void;
  onExit: () => void;
  children: ReactNode;
}
const LeadMagnetShell: FC<Props> = t0 => {
  const $ = _c(12);
  const {
    logo,
    exitLabel,
    onLogoClick,
    onExit,
    children
  } = t0;
  let t1;
  if ($[0] !== logo || $[1] !== onLogoClick) {
    t1 = logo ? <button className={css.logoLink} aria-label="Qream" onClick={onLogoClick}><Image preload={true} className={css.logo} src={logo.url} alt={logo.alt || "Qream"} width={logo.width ?? 90} height={logo.height ?? 20} /></button> : <span />;
    $[0] = logo;
    $[1] = onLogoClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== exitLabel || $[4] !== onExit) {
    t2 = <AnimatedButton type="button" className={css.exitButton} onClick={onExit}>{exitLabel}</AnimatedButton>;
    $[3] = exitLabel;
    $[4] = onExit;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <header className={css.topBar} data-lead-magnet-top-bar="">{t1}{t2}</header>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== t3) {
    t4 = <div className={css.shell} data-lead-magnet-shell="">{t3}{children}</div>;
    $[9] = children;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default LeadMagnetShell;